<template>
  <div class="login">
    <v-container>
      <v-row class="mt-10 flex-column align-center">
        <div>
          <v-col cols="12" sm="12" md="12">
            <v-img max-height="270" max-width="270" src="../assets/Mendoza-Fiduciaria-logo.png"></v-img>
            <h2 class="text-center">Crear nueva cuenta</h2>
          </v-col>
        </div>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8" offset-sm="2" sm="8" offset-lg="4" lg="4">
          <section>
            <v-row>
              <v-col cols="6" align="right">
                <input type="radio" id="personaFisica" value="1" v-model="tipoCliente" checked />
                <label for="personaFisica">&nbsp;Persona f&iacute;sica</label>
              </v-col>
              <v-col cols="6" align="left">
                <input type="radio" id="empresa" value="0" v-model="tipoCliente" />
                <label for="empresa">&nbsp;Empresa</label>
              </v-col>
            </v-row>
          </section>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8" offset-sm="2" sm="8" offset-lg="4" lg="4">
          <v-form ref="registerForm" v-model="formValid">
            <div v-if="tipoCliente === '1'">
              <v-col cols="12">
                <v-text-field label="Nombre" :rules="nombreRules" v-model="nombre" v-on:keyup.enter="register">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Apellido" :rules="apellidoRules" v-model="apellido" v-on:keyup.enter="register">
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Número de CUIT"
                  v-model="cuit"
                  :rules="cuitRules"
                  v-on:keyup.enter="register"
                  placeholder="Sin guiones"
                >
                </v-text-field>
              </v-col>
            </div>
            <div v-if="tipoCliente === '0'">
              <v-col cols="12">
                <v-text-field
                  label="Razón social"
                  :rules="razonSocialRules"
                  v-model="razonSocial"
                  v-on:keyup.enter="register"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Número de CUIT"
                  v-model="cuit"
                  :rules="cuitRules"
                  v-on:keyup.enter="register"
                  placeholder="Sin guiones"
                >
                </v-text-field>
              </v-col>
            </div>
            <v-col cols="12">
              <v-text-field
                label="Nro. Contacto:"
                :rules="telefonoRules"
                v-model="telefono"
                filled
                autocomplete="false"
                v-on:keyup.enter="register"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Usuario:"
                v-model="usuario"
                :rules="usuarioRules"
                filled
                autocomplete="false"
                v-on:keyup.enter="register"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Dirección de e-mail"
                :rules="emailRules"
                v-model="email"
                filled
                autocomplete="false"
                v-on:keyup.enter="register"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Contraseña"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                :rules="confirmPasswordRules"
                v-model="password"
                filled
                autocomplete="new-password"
                v-on:keyup.enter="register"
                name="password"
                required
                counter
                @click:append="show = !show"
              >
              </v-text-field>
            </v-col>
            <div class="text-center">
              <v-btn color="success" @click="register"> Registrarse </v-btn>
            </div>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="3" md="6" offset-sm="2" sm="8">
          <v-alert :value="alert" color="#F29398" dark border="top" icon="mdi-cancel" transition="scale-transition">
            <v-row align="center">
              <v-col class="grow">{{ this.mensaje }}</v-col>
              <v-col class="shrink">
                <v-btn color="#EC6D75" @click="cerrarBoton">X</v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { API_URL } from '@/common/config';

const axios = require('axios');

export default {
  name: 'Register',
  data: () => ({
    formValid: false,
    show: false,
    tipoCliente: '1',
    email: '',
    usuario: '',
    password: '',
    nombre: '',
    apellido: '',
    cuit: '',

    telefono: '',
    razonSocial: '',
    sectorProductivo: '',
    sectorProductivos: [],
    mensaje: '',
    alert: false,
    text: '',
    telefonoRules: [
      (v) => !v || /^[0-9]{6,}$/.test(v) || 'El número de contacto debe tener al menos 6 dígitos numéricos',
    ],
    nombreRules: [(v) => !!v || 'El campo nombre es obligatorio'],
    apellidoRules: [(v) => !!v || 'El campo apellido es obligatorio'],

    razonSocialRules: [(v) => !!v || 'La razón social es obligatoria'],
    usuarioRules: [
      (v) => !!v || 'El usuario es obligatorio',
      (v) => /^[a-zA-Z0-9_]{4,}$/.test(v) || 'El usuario debe tener al menos 4 caracteres alfanuméricos',
    ],
    emailRules: [
      (v) => !!v || 'El correo electronico es obligatorio',
      (v) => /.+@.+/.test(v) || 'El correo electronico no es valido',
    ],
    cuitRules: [
      (v) => !v || /^[0-9]{6,}$/.test(v) || 'El CUIT debe contener al menos 11 dígitos numéricos',
      (v) => !!v || 'El CUIT es obligatorio',
    ],
  }),
  computed: {
    confirmPasswordRules() {
      console.log('ok');

      return [
        (v) => !!v || 'Ingresar una clave',
        (v) => (v && v.length >= 8) || 'La contraseña debe tener al menos 8 caracteres', // Cambiado a 8 caracteres
        (v) =>
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(v) ||
          'La contraseña debe incluir al menos una letra minúscula, una mayúscula, un dígito y un carácter especial (@$!%*?&)',
      ];
    },
  },
  watch: {
    nombre() {
      this.generarUsername();
    },
    apellido() {
      this.generarUsername();
    },
    razonSocial() {
      this.generarUsername();
    },
    cuit() {
      this.generarUsername();
    },
    email() {
      this.generarUsername();
    },
    tipoCliente(newVal, oldVal) {
      if (newVal === '1' && oldVal === '0') {
        this.clearCompanyData();
      } else if (newVal === '0' && oldVal === '1') {
        this.clearPersonData();
      }
    },
  },
  methods: {
    clearPersonData() {
      this.nombre = '';
      this.apellido = '';

      this.cuit = '';
      this.telefono = '';
      this.email = '';
      this.password = '';
      this.usuario = '';
    },
    clearCompanyData() {
      this.razonSocial = '';
      this.cuit = '';
      this.cuit = '';
      this.telefono = '';
      this.email = '';
      this.password = '';
      this.usuario = '';
    },
    async register() {
      // const { valid } = await this.$refs.registerForm.validate();

      // if (!valid) {
      //   // Si el formulario no es válido, muestra un mensaje de error
      //   this.$swal.fire({
      //     title: 'Error',
      //     text: 'Por favor, complete todos los campos correctamente',
      //     icon: 'error',
      //     confirmButtonText: 'OK',
      //     confirmButtonColor: '#f32',
      //   });
      //   return;
      // }

      const registrationData = {
        username: this.usuario,
        email: this.email,
        password: this.password,
        rol: 3, // Consider making this dynamic based on user type if needed.
        telefono: this.telefono,
        sectorProductivo: 5,
        tipoCliente: parseInt(this.tipoCliente, 10),
      };

      if (this.tipoCliente === '1') {
        // Persona Física
        registrationData.nombre = this.nombre;
        registrationData.apellido = this.apellido;
        registrationData.cuit = this.cuit;
        registrationData.razonSocial = '';

        // Validaciones específicas para tipoCliente === 1
        if (!this.nombre || !this.apellido || !this.cuit) {
          this.$swal.fire({
            title: 'Error',
            text: 'Por favor, complete los campos: nombre, apellido y CUIT',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#f32',
          });
          return;
        }
      } else {
        // Empresa
        registrationData.razonSocial = this.razonSocial;
        registrationData.cuit = this.cuit;

        registrationData.nombre = '';
        registrationData.apellido = '';
        // Validaciones específicas para tipoCliente === 0
        if (!this.razonSocial || !this.cuit) {
          this.$swal.fire({
            title: 'Error',
            text: 'Por favor, complete los campos: razón social y CUIT',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#f32',
          });
          return;
        }
      }

      axios
        .post(`${API_URL}api/v1/auth/register`, registrationData)
        .then(async (response) => {
          if (response.data.status === 'error') {
            this.mensaje = response.data.message;
            this.alert = true;
          } else {
            // Success handling (same as before)
            this.$swal({
              title: 'Usuario Registrado',
              text: `Usuario: ${response.data.usuario[0].email}, revise su mail para comenzar a operar`,
              showDenyButton: false,
              icon: 'success',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#78B04E',
            }).then(async (result) => {
              if (result.isConfirmed) {
                localStorage.setItem('email', this.email);
                this.mensaje = 'Usuario registrado';
                this.$router.push('/');
              }
            });
          }
        })
        .catch((error) => {
          // Error handling (same as before)
          const { message } = error.response.data;
          this.$swal.fire({
            title: 'Error',
            text: 'Ocurrió un error al generar el usuario',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#f32',
          });
          this.alert = true;
          this.mensaje = `Error al crear el usuario: ${message}`;
        });
    },
    cerrarBoton() {
      this.alert = false;
    },
    login() {
      this.$router.push('/login');
    },
    redireccion() {
      const token = localStorage.getItem('token');
      if (token !== 'undefined' && token !== null && token !== '') {
        axios
          .post(`${API_URL}api/usuarios/validarToken`, {
            token: localStorage.getItem('token'),
          })
          .then(() => {
            this.$router.push('/');
          });
      }
    },
    async loadSectorProductivos() {
      const url = `${API_URL}api/sectoresProductivos`;
      await axios
        .get(url)
        .then((response) => {
          if (response.data.status === 'success') {
            this.sectorProductivos = response.data.sectoresProductivos.map((f) => ({
              value: f.id,
              text: f.nombre,
            }));
          } else {
            console.log('Error al obtener los datos');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async generarUsername() {
      // Verificar si el usuario ya tiene un valor manual
      if (this.usuario.length < 0) return;

      // Generar username basado en nombre y apellido
      const numberCuit = this.cuit ? this.cuit.slice(-4) : '';
      if (this.nombre && this.apellido) {
        this.usuario = `${this.nombre[0].toLowerCase()}${this.apellido
          .toLowerCase()
          .replace(/\s+/g, '')}${numberCuit || ''}`;
      } else if (this.razonSocial) {
        // Si no hay nombre y apellido, usar la razón social
        this.usuario = `${this.razonSocial.toLowerCase().replace(/[\s.,]/g, '')}${numberCuit || ''}`;
      }
    },
  },
  created() {
    this.redireccion();
    this.loadSectorProductivos();
  },
};
</script>
